import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {IST_REPORT, RESPONSE} from '../../resources/constant';
import {getAllFilesByReportTypes, getDBAName} from '../../Utilities/WSUtil';
import {retentionYears, allMonths, allDays, zeroPad} from '../../Utilities/DatePicker';
import {Row,Col,Form, Modal} from 'react-bootstrap';
import OverlayLoader from 'react-overlay-loading/lib/OverlayLoader';
import renderHTML from 'react-render-html';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn, MidCifBtn} from '../../theme/MorsTheme';
import MerchantPicker from '../../Utilities/MerchantPicker'

export default class SearchISTReport extends Component{
    constructor(props){
        super(props);        
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleChange = this.toggleChange.bind(this);
        this.blurChange = this.blurChange.bind(this);
        this.isInputValid = this.isInputValid.bind(this);
        //Monina start - added
        this.updateToAllDays = this.updateToAllDays.bind(this);
        this.updateFromAllDays = this.updateFromAllDays.bind(this);
        //Monina end - added
        this.state = {            
            cu:JSON.parse(localStorage.getItem(RESPONSE)),
            checkedAllReport:false, 
            searchSingleId: '',
            btnShow: false,
            btnShow2: false,
            fetchMessage:'',
            loading:false,
            names:[],
            toAllDays: allDays, //Monina added
            fromAllDays: allDays, //Monina added                    
        };
    }      
    
    selectMerchantPicker = (mer) =>{
        this.setState({
            fetchMessage:'',
            searchSingleId: mer.id,
            names:{ legalName: mer.corpName, 
                    corpName: mer.dbaName}
        })
    }
    
    isInputValid(){
        var dateFrom = new Date(document.getElementById('fromMonth').value+
        '/'+document.getElementById('fromDay').value +
        '/'+document.getElementById('fromYear').value);

        var dateTo = new Date(document.getElementById('toMonth').value+
        '/'+document.getElementById('toDay').value +
        '/'+document.getElementById('toYear').value);


        var timeDiff = Math.abs(dateTo.getTime() - dateFrom.getTime());
        var dateDiff = (timeDiff / (1000 * 3600 * 24)) + 1;
        
        if(this.state.searchSingleId === '' && this.state.checkedAllReport === false){                        
            alert('Merchant ID cannot be null')            
            return false;
        }

        if(!(this.state.checkedAllReport && this.state.cu.user.allReportAccess)){
            if(dateFrom > dateTo){
                alert('Date To must be greater than Date From.')            
                return false;
            }

            if(dateDiff > 31 ){
                alert('Date range should not exceed to 31 days.');            
                return false;
            }
        }

        if(this.state.fetchMessage!=='' && this.state.searchSingleId !== '' ){
            if(this.state.checkedAllReport === false){
                alert('Please input a valid Merchant ID.');            
                return false;
            }
        }
    
        return true;
    }
    componentWillMount(){
        this.setState({
            btnShow: this.state.cu.user.allReportAccess,
            btnShow2: this.state.cu.user.allReportAccess,
            names:{legalName: '', corpName: ''},
            fetchMessage:''
        })
    }
    
    toggleChange = () => {
        this.setState({
            checkedAllReport: !this.state.checkedAllReport,
            searchSingleId:'',
            names:{legalName: '', corpName: ''},
            fetchMessage:'',
            btnShow2: !this.state.btnShow2
        });
      }

      blurChange(e){
        e.preventDefault();     
        if(this.state.searchSingleId !== "")       
        getDBAName(this.state.cu.user.userId, this.state.searchSingleId).then(response =>             
            ({
                legalName: `${response.dbaName}`,
                corpName: `${response.corpName}`
            })                                                
        ).then(names => this.setState({names, fetchMessage:''}))                
        .catch(error =>{            
            this.setState({
                fetchMessage: `Sorry, the Merchant lD you're searching for does not exist in our system. <br/>
                Please check the details you selected and try again. `
            })                                     
        
        })       
    }

    //Monina start - added
    updateToAllDays(e){
        var toYear = document.getElementById('toYear').value;
        var toMonth = document.getElementById('toMonth').value;
        var valYear = (typeof toYear !== 'undefined') ? toYear : 0;
        var valMonth = (typeof toMonth !== 'undefined') ? toMonth : 0;
        this.setState({
            [e.target.id]: e.target.value, 
            toAllDays: this.updateAllDays(valYear, valMonth)});
    }

    updateFromAllDays(e){
        var fromYear = document.getElementById('fromYear').value;
        var fromMonth = document.getElementById('fromMonth').value;
        var valYear = (typeof fromYear !== 'undefined') ? fromYear : 0;
        var valMonth = (typeof fromMonth !== 'undefined') ? fromMonth : 0;
        this.setState({
            [e.target.id]: e.target.value, 
            fromAllDays: this.updateAllDays(valYear, valMonth)});
    }

    updateAllDays(year, month){
        var selDate = new Date(year, month, 0);
        var arrResult = [];
        Array.from(Array(selDate.getDate())).map((e,i)=>i+1).forEach(function(value, idx){
            arrResult[idx+1] = value;
        });
        return arrResult;
    }
    //Monina end - added
        
    handleChange(e){
        this.setState(
            {                
                [e.target.id]: e.target.value   
            }
        )
    }
   
    handleSubmit(event) {
        event.preventDefault();                  
        var date_From = document.getElementById('fromMonth').value+
        '/'+document.getElementById('fromDay').value +
        '/'+document.getElementById('fromYear').value;

        var date_To = document.getElementById('toMonth').value +
        '/'+document.getElementById('toDay').value +
        '/'+document.getElementById('toYear').value;
                

        if(this.isInputValid()){
            
            if(this.state.checkedAllReport && this.state.cu.user.allReportAccess){
                date_To = date_From;
            }

            this.setState({loading:true})                       
            getAllFilesByReportTypes(                      
                this.state.cu.user.userId,
                this.state.cu.user.groupId,
                "1",          
                "1",
                date_From,
                date_To,            
                IST_REPORT,            
                this.state.searchSingleId,            
                this.state.checkedAllReport
            ).then(response => {       
                this.setState({loading:false})       
                this.props.getTypeReport(IST_REPORT);   
                this.props.getReports(response);            
                this.props.history.push("/reportsFileList");
            }).catch(error => {
                this.setState({loading:false})
            })
        }    
    }

    render(){                      
        const {legalName, corpName} = this.state.names;                   
        return(       
            <div>           
            <BodyHeaderDiv>
                   <BodyHeaderText>Search IST Report</BodyHeaderText>
           </BodyHeaderDiv>
           <ContentDiv>
           <Row>
               <Col>
                    <Row>
                        <Col>
                        <span style={{fontSize:'11px', color:'red', lineHeight:'5px'}}>
                        {renderHTML(this.state.fetchMessage)}
                        </span>
                        </Col>
                    </Row>
                    <Row>
                    <Col md={3}></Col>                
               <Col md={6}>
               <Form onSubmit={this.handleSubmit}>                          
                   <Form.Label size='sm' style={{fontWeight:'bold'}}>View Report for one (1) Merchant ID</Form.Label>
                   <Form.Row>                        
                       <Form.Group as={Col} sm={this.state.btnShow?12:10} controlId="searchSingleId" onChange={this.handleChange} onBlur={this.blurChange}>                                                
                           <Form.Control maxLength={10} size='sm' type="text"  value={this.state.searchSingleId} disabled={this.state.checkedAllReport}></Form.Control>                                                                            
                       </Form.Group>        
                       <Form.Group  as={Col} hidden={this.state.btnShow}>                           
                           {/* <Link to='/merchantPicker' onClick={this.windowOpen}><MidCifBtn>...</MidCifBtn></Link> */}
                            <Form.Group  as={Col} hidden={this.state.btnShow2}>
                                <MerchantPicker userId = {this.state.cu.user.userId} getMerchant = {this.selectMerchantPicker}/>
                            </Form.Group>
                       </Form.Group>                                                                                        
                   </Form.Row>
                   <Form.Label size='sm' style={{fontWeight:'bold'}}>Report Date From</Form.Label>
                   <Form.Row>                                                
                       <Form.Group as={Col} controlId="fromMonth" onChange={this.updateFromAllDays}>                                                            
                           <Form.Control as="select" size='sm'>
                           {   allMonths.map((option, index) =>                             
                               <option key={index} value={option.id}>{option.month}</option> )  
                           }                              
                           </Form.Control>                                                                
                       </Form.Group>
                       <Form.Group as={Col} controlId="fromDay" onChange={this.handleChange}>                                                                                            
                           <Form.Control as="select" size='sm'>
                           {   this.state.fromAllDays.map((option, index) =>                                 
                               <option key={index} value={zeroPad(option,2)}>{option}</option>)
                           }                             
                           </Form.Control>                                                                
                       </Form.Group>
                       <Form.Group as={Col} controlId="fromYear" onChange={this.updateFromAllDays}>                                                                                            
                           <Form.Control as="select" size='sm'>
                           {   retentionYears.sort((a,b) => b - a).map((option, index) =>                                                                                              
                               <option key={index} value={option}>{option}</option>)
                           }                            
                           </Form.Control>                                                                
                       </Form.Group>                                                         
                   </Form.Row>
                   {/* <Form.Label size='sm' style={{fontWeight:'bold'}}>To</Form.Label> */}
                   {/* <Form.Row> */}
                    <Form.Label size='sm' style={{fontWeight:'bold'}} hidden={this.state.checkedAllReport?this.state.btnShow?true:false:false} >To</Form.Label>
                    <Form.Row hidden={this.state.checkedAllReport?this.state.btnShow?true:false:false}> 
                       <Form.Group as={Col} controlId="toMonth" onChange={this.updateToAllDays}>
                           <Form.Control as="select" size='sm' >
                           {   allMonths.map((option, index) =>
                               <option key={index} value={option.id}>{option.month}</option>)                          
                           } 
                           </Form.Control>                            
                       </Form.Group>
                       <Form.Group as={Col} controlId="toDay" onChange={this.handleChange}>
                           <Form.Control as="select" size='sm' >
                           {   this.state.toAllDays.map((option, index) => 
                               <option key={index} value={zeroPad(option,2)}>{option}</option>)
                           } 
                           </Form.Control>                            
                       </Form.Group>
                       <Form.Group as={Col} controlId="toYear" onChange={this.updateToAllDays}>
                           <Form.Control as="select" size='sm' >
                           {   retentionYears.sort((a,b) => b - a).map((option, index) =>                                   
                               <option key={index} value={option}>{option}</option>)
                           } 
                           </Form.Control>                            
                       </Form.Group>
                   </Form.Row>
                   
                   <Form.Row>
                       <Form.Group as={Col} controlId="legalName" onChange={this.handleChange}>
                           <Form.Label size='sm' style={{fontWeight:'bold'}}>Legal Name</Form.Label>
                           <Form.Control tyle={{width:this.state.btnShow?'100%':'95%'}} type="text" value={legalName} size='sm' disabled></Form.Control>
                       </Form.Group>
                   </Form.Row>

                   <Form.Label size='sm' style={{fontWeight:'bold'}}>DBA Name</Form.Label>
                   <Form.Row>
                       <Form.Group as={Col} sm={this.state.btnShow?12:10} controlId="dbaName" onChange={this.handleChange}>                            
                           <Form.Control type="text" value={corpName} size='sm' disabled></Form.Control>                            
                       </Form.Group>
                       <Form.Group as={Col} hidden={this.state.btnShow}>
                            <Form.Group as={Col} hidden={this.state.btnShow2}>
                                <MerchantPicker userId = {this.state.cu.user.userId} getMerchant = {this.selectMerchantPicker}/>
                            </Form.Group>
                       </Form.Group> 
                   </Form.Row>


                   <Form.Row>
                       <Form.Group as={Col} controlId="checkedAllReport" onChange={this.toggleChange}>
                           <Form.Check size='lg' label='View Reports for Multiple Merchant IDs' style={{fontWeight:'bold'}}/>                                                                                                                                            
                       </Form.Group>
                   </Form.Row>                      
                   <div align="center">
                   <Col hidden={!(this.state.checkedAllReport && this.state.cu.user.allReportAccess)} >
                        <span style={{fontSize:'11px', color:'red', lineHeight:'5px'}}>
                                Users with access to all MIDs are limited to single date search. Please select a date.
                        </span>
                    </Col>
                        <SubmitBtn style={{color:'#FFFFFF'}}>View Reports</SubmitBtn> 
                    </div>
                </Form>  
                    </Col>
                    <Col md={3}>
                    </Col>

                    </Row>
               </Col>
               
                </Row>
            </ContentDiv>        
            <Modal show={this.state.loading} backdrop={'static'}  centered={true} backdropClassName='fade' dialogClassName="modal-bdox">  
                    <div>
                        <OverlayLoader
                            color={'#0B2972'}
                            loader="ClipLoader"
                            text="Loading..."
                            active={true}
                            backGroundColor={'black'}
                            opacity=".9">
                        </OverlayLoader>                
                    </div>                                  
                </Modal>                                    
        </div>

        )
    }
}


